import { render } from "./CardFooter.vue?vue&type=template&id=e2204da2"
import script from "./CardFooter.vue?vue&type=script&lang=js"
export * from "./CardFooter.vue?vue&type=script&lang=js"
script.render = render

export default script